import { render } from "./settings-tabset.vue?vue&type=template&id=77486250"
import script from "./settings-tabset.vue?vue&type=script&lang=js"
export * from "./settings-tabset.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__